<template>
  <div class="failed-box">
    <div class="filter-box">
      <div class="date-input">
        <datepicker :format="calendarFormat" v-model="start"
          :class="['datepicker inline', {'has-error':!!validation.start}]"
        ></datepicker>
        <span class="error-msg">{{validation.start}}</span>
      </div>
      <div class="date-input">
        <datepicker :format="calendarFormat"  v-model="end"
          :class="['datepicker inline', {'has-error':!!validation.end}]"
        ></datepicker>
        </div>
      <button @click="getFailedList" class="button cta small" >
        Submit
      </button>
    </div>

    <table class="table-box" cellspacing="0">
        <thead>
          <th>RSVP</th>
          <th>Stripe</th>
        </thead>
        <tbody>
          <tr v-if="list && !list.length">
            <td colspan="2" class="empty">No record found.</td>
          </tr>
          <tr v-for="dat in list">
            <td>
              <a :href="'/#/reservation/' + dat.rsvpId" class="link" target="_blank">{{dat.rsvpId}}</a>
            </td>
            <td>
              <a :href="stripLink(dat.stripeCustId)" class="stripe link" target="_blank">{{dat.stripeCustId}}</a>
            </td>
          </tr>
        </tbody>
      </table>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import datepicker from 'vuejs-datepicker'

export default {
  name: 'failed',
  components: { datepicker },
  data () {
    return {
      triggerOnLoad: false,
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      list: []
    }
  },
  computed: {
  },
  methods: {
    checkLoaded () {
      if (!this.triggerOnLoad) {
        this.triggerOnLoad = true
        this.getFailedList()
      }
    },
    calendarFormat (date) { return moment(date).format('MM/DD/YYYY') },
    getFailedList () {
      let self = this

      let start = moment(self.start, 'MM/DD/YYYY').set('hour', 0).set('minute', 0)
      let end = moment(self.end, 'MM/DD/YYYY').set('hour', 23).set('minute', 59)
      self.validation.start = ''
      if (end.diff(start, 'days') < 0) {
        self.validation.start = 'Cannot be greater than end date.'
        return
      }

      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.get('/utils/listfailed', {
        start: start.format('YYYY-MM-DD'),
        end: end.format('YYYY-MM-DD')
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        self.list = r.list
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
        }
      }, '')
    },
    stripLink (x) {
      let url = 'https://dashboard.stripe.com/customers/'
      if (CONFIG.Env !== 'production') url = 'https://dashboard.stripe.com/test/customers/'
      return `${url}${x}`
    }
  },
  mounted () {
    this.start = moment().format('MM/DD/YYYY')
    this.end = moment().format('MM/DD/YYYY')
  }
}
</script>

<style lang="scss" scoped>
.failed-box{
  padding: 15px;
}

.filter-box{
  display: flex;
  width: 100%;
  border: 1px solid #ccc;
  background: #fafafa;
  padding: 15px;
  border-radius: 4px;
  align-items: start!important;
  
  .error-msg{
    font-size: 13px;
    color: #f00;
  }
  .button{
    line-height: 20px;
    padding: 10px 20px;
  }
}
.datepicker{
  margin-right: 10px;
}

.table-box{
  margin-top: 30px;
  width: 100%;
  border: 1px solid #333;
  background: #fafafa;
  border-radius: 4px;
  overflow: hidden;

  th{
    border-bottom: 1px solid #ddd;
    padding: 5px;
    background: #333;
    color: #fff;
  }
  tr{
    text-align: center;
  }
  td{
    padding: 7px;
  }
  tr:nth-child(odd) td{
    background: #f3f3f3;
  }
  .empty{
    padding: 30px;
    font-weight: 600;
    font-size: 28px;
    color: #777;
  }
}

.link{
  font-size: 14px;
  font-weight: 600;
}

@media only screen and (max-width: 430px){
  .filter-box {
    display: flex;
    flex-wrap: wrap;

    .date-input {
      width: 50%;

      
      &:nth-of-type(2) {
        .datepicker {
          margin: 0;
        }
        /deep/ .vdp-datepicker__calendar {
          right: 0;
        }
      }

    }

    .button {
      width: 100%;
      margin-top: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdminCode/failed.vue